// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"363":"32b1de5cee79","563":"74c513121ec4","2329":"792b1fabd101","5060":"2f898b9c13a6"}[chunkId] + ".css";
};